import React, { ReactNode, Children } from 'react';
import AdContainer from '../../../../components/ads';
import * as S from './styles';
import AdvizedWidget from '../../../../components/advized';
import { AdvizedContentFragment } from '../../../../types';

type Props = {
  children: ReactNode[];
  advized?: AdvizedContentFragment | null;
};

const advertSpacing = { bottom: '10px' };

export const AdsGridContainer = ({ children, advized }: Props) => {
  const offersOrProductLength = Children.count(children);
  return (
    <S.ProductGrid data-test="ProductGrid">
      {offersOrProductLength > 4 && (
        <S.Advert row={2} key="panorama_extra">
          <AdContainer
            scalable
            scaleBase=".pj-ui-panel"
            scaleOrigin="left center"
            placement="panorama_extra"
            format="panorama_1_wde"
            min={861}
            max={10000}
            spacing={advertSpacing}
          />
        </S.Advert>
      )}

      {offersOrProductLength > 2 && (
        <S.Advert row={2} key="dubbelpanorama1">
          <AdContainer
            placement="dubbelpanorama1"
            format="panorama_1"
            min={0}
            max={860}
            spacing={advertSpacing}
          />
        </S.Advert>
      )}

      {offersOrProductLength > 18 && (
        <S.Advert row={8} key="dubbelpanorama2">
          <AdContainer
            placement="dubbelpanorama2"
            format="panorama_2"
            min={0}
            max={860}
            spacing={advertSpacing}
            triggerPoint={100}
          />
        </S.Advert>
      )}

      {advized && <AdvizedWidget {...advized} grid />}

      {Children.map(children, (child, index) => (
        <S.ProductGridItem style={{ order: index }}>{child}</S.ProductGridItem>
      ))}
    </S.ProductGrid>
  );
};
